import React, {Component} from "react";
import {Link} from "react-router";
import {connect} from "react-redux";
import applogic from "../applogic.js";
import ReactImageFallback from "react-image-fallback";

class VideoList extends Component {
    render() {
        let videos = this.props.videos, videoList;
        if (videos && videos.length > 0) {
            videoList = this.props.videos.map(v => {
                let thumbnail = applogic.getThumbnailUrlOrPlaceholder(v);
                return (<div className="video-thumbnail col-lg-4 px-2" key={v.ID}>
                    <Link to={"/v/" + v.ID}>
                        <div className="video-thumbnail-wrapper">
                            <ReactImageFallback
                                src={thumbnail}
                                fallbackImage="https://ivle.nus.edu.sg/images/video_thumb.jpg"
                                initialImage="/img/loader.gif"
                                alt=""
                                className="video-thumbnail" />
                        </div>
                        <div className="video-banner-name">{v.courseCode + ': ' + v.name}</div>
                    </Link>
                    <p className="video-banner-time">Uploaded: {new Date(v.time).toUTCString().replace(/\s*(GMT|UTC)$/, "") || ''}</p>
                    <p><span className="video-banner-views">{v.views} Views</span>&nbsp;|&nbsp;
                        <span className="video-banner-comments">{v.comments || 0} Comments</span></p>
                </div>);
            });
        } else {
            videoList = <div className="col-lg-6 px-2 no-video">No available videos</div>
        }
        return (
            <div className="container video-list-wrapper">
                <h2 className="video-list-title">{this.props.type}</h2>
                <div className="row">
                    {videoList}
                </div>
            </div>
        );
    }
}

export default connect()(VideoList);


// WEBPACK FOOTER //
// ./src/componentsBody/VideoList.js